export default __webpack_public_path__ + "static/media/hero-image.f29facb8.svg";